export const GIT_COMMIT = 'dev';
